import React, { useCallback, useState } from "react";
import { Redirect } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Box } from "@chakra-ui/react";
import { EvaluationModal } from "../../components/EvaluationModal";
import { EvaluationCard } from "../../components/EvaluationCard";
const Results: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  // const { enqueueSnackbar } = useSnackbar();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleSubmit = useCallback(
    async (email: string, password: string) => {
      try {
        await session.login(email, password);
      } catch (err) {
        console.log(err);
        // enqueueSnackbar(t("screens.login.loginError"), {
        //   variant: "error",
        // });
      }
    },
    [session, t]
  );

  // if (session.isLogged) {
  //   return <Redirect to={"/"} />;
  // }

  return (
    <Box p={30} w={"100%"}>
      {/* <EvaluationCard
       isOpen={isModalVisible}
       evaluation={evaluation}
       onClose={() => {
         setIsModalVisible(false);
         setEvaluation(null);
       }}
       onSubmit={handleSubmit}
      /> */}

      <EvaluationModal
        isOpen={isModalVisible}
        evaluation={null}
        onClose={() => {
          setIsModalVisible(false);
        }}
        onSubmit={() => {}}
      />
    </Box>
  );
});

export default styled(Results)`
  & {
    .fc .fc-col-header-cell-cushion {
      display: inline-block;
      padding: 2px 4px;
    }
    .fc-theme-standard td,
    .fc-theme-standard th {
      background-image: linear-gradient(
        to right,
        #ccc 0%,
        #ccc 50%,
        transparent 50%
      );
      background-size: 12px 1px;
      background-repeat: repeat-x;
      border: 0px solid !important;
    }
    td {
      border: 0px solid !important;
    }
  }
`;
